module.exports = __webpack_public_path__ + "static/media/Food.2ec3518d.png";